export default __webpack_public_path__ + "b88adeb66c70dcc5a51bdb5a531ddfcd.png";